import { useFeature } from '../../../components/hooks/isFeatureEnabled';
import { CHECK_LIVE_STATUS } from '../../../constants/features/constants';
import { TrackEventLinkWithIcon } from '../../../components/track-event-link/TrackEventLinkWithIcon';
import { useProject } from '../../project-hooks/useProject';
import styles from './IsLive.module.less';
import { useSelector } from 'react-redux';
import { getLiveStatusForProject } from '../../../live-status/live-status-reducer';

const IsLive = () => {
    const useCheckLiveStatus = useFeature(CHECK_LIVE_STATUS);
    const project = useProject();
    const twitchUserId = project?.profile?.twitchUserId;
    const showLiveIndicator = project?.profile?.showLiveIndicator;
    const isLive = useSelector((state) => getLiveStatusForProject(state, project?.id));

    if (!useCheckLiveStatus || !twitchUserId || !isLive || !showLiveIndicator) {
        return null;
    }

    return (
        <div className={styles.liveStatusWrapper}>
            <div className={styles.liveStatusIcon} />
            <span className={styles.liveStatusText}>
                Direkte nå! Se på{' '}
                <TrackEventLinkWithIcon
                    to={`https://www.twitch.tv/${twitchUserId}`}
                    target="_blank"
                    icon="fa-brands fa-twitch"
                >
                    {twitchUserId}
                </TrackEventLinkWithIcon>
            </span>
        </div>
    );
};

export default IsLive;
